import React from 'react';
import { CardTitle } from 'reactstrap';

const AIResponseExplanation = ({ explanation }) => {
    return (
        <div className="card card-plain" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <CardTitle tag="h4" style={{ padding: 5, paddingTop: 10, textAlign: 'center' }}>
                AI Assist Summary
            </CardTitle>
            <div className="card-body" style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '60%', textAlign: 'left', marginTop: '-15px' }}>
                    <p className="card-text" style={{ color: 'orange' }}>
                        {explanation}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AIResponseExplanation;
